import React from 'react';
import LoginPage from '../../shared/components/LoginPage';

const AdminLoginPage = () => {
    // This component simply renders the shared LoginPage
    // and passes the 'admin' role to it.
    return <LoginPage role="admin" />;
};

export default AdminLoginPage;
